import { render, staticRenderFns } from "./LicenseTransfer.vue?vue&type=template&id=5cf7842b&"
import script from "./LicenseTransfer.vue?vue&type=script&lang=js&"
export * from "./LicenseTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports